/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { PureComponent } from 'react';
import { object, shape, string, func } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import p from 'polyglot/polyglot';

import { createUrl } from 'utils/urlHelper';

import { authenticate as authenticateAction } from 'actions/auth';

import Button from 'components/Button/Button';

import styles from './edit-mode-menu.scss';

/**
 * This is the EditModeMenu component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class EditModeMenu extends PureComponent {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    app: object.isRequired,
    auth: object.isRequired,
    user: shape({
      fullname: string.isRequired,
    }).isRequired,
    authenticate: func.isRequired,
    history: object.isRequired,
  };

  onClick = () => {
    const {
      app: { locale },
      auth: { provider },
      authenticate,
      history,
    } = this.props;

    // reload to fetch correct data.
    window.location.href = createUrl('talents');

    // First replace the current location.
    // history.replace(createUrl('talents'));

    // Then we reset the user and remove the as_user params.
    // authenticate({
    //   ...provider,
    //   language: locale,
    // });
  };

  /**
   * Render EditModeMenu.
   *
   * @return {Object}
   */
  render() {
    const {
      user: { fullname },
    } = this.props;

    return (
      <div className={styles.wrapper}>
        <p className={styles.title}>
          {p.t('header.menu.edit_mode.title', { name: fullname })}
        </p>

        <Button onClick={this.onClick} small>
          {p.t('header.menu.edit_mode.return_button')}
        </Button>
      </div>
    );
  }
}

export default withRouter(
  connect(({ app, auth, user }) => ({ app, auth, user }), {
    authenticate: authenticateAction,
  })(EditModeMenu)
);
